import { useState } from 'react';

export function useInitOnce(action: () => void): void {
  const [initDone, setInitDone] = useState(false);
  if (!initDone) {
    action();
    setInitDone(true);
  }
}
